<template>
  <div class="bm-register">
    <!--<h3 class="center">账号注册</h3>-->
    <van-cell-group>
      <van-field v-model="userName" label="手机号" placeholder="请输入手机号"/>
      <van-field v-model="smsCode" center label="短信验证码" placeholder="请输入短信验证码">
        <van-button slot="button" size="small" type="primary" @click="sendSmsCode">{{sendCodeLabel}}</van-button>
      </van-field>
    </van-cell-group>
    <div class="submit">
      <van-button :loading="isLoading" plain type="primary" size="large" @click="submitSmsHandler"
                  loading-type="spinner" loading-text="验证中...">完成</van-button>
      <van-button class="margin-top" type="default" size="large" @click="goLogin">已有账号？去登录</van-button>
    </div>
    <div class="note">
      <span>登录即代表阅读并同意</span>
      <a href="http://www.banmabang.cn/m/protocol.html">《斑马邦用户协议》</a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { sendSmsCode } from '@/api/user'
import { Tab, Tabs, Field, CellGroup, Toast } from 'vant'

Vue.use(Tab).use(Tabs).use(Field).use(CellGroup).use(Toast)

const TIME_COUNT = 60
const beforeSend = '发送验证码'
const afterSend = 's后再次发送'
export default {
  name: 'Login',
  data() {
    return {
      count: TIME_COUNT,
      timer: null,
      show: true,
      isLoading: false,
      userName: '',
      password: '',
      smsCode: '',
      sendCodeLabel: beforeSend
    }
  },
  methods: {
    submitSmsHandler(e) {
      this.isLoading = true
      const params = {
        userName: this.userName,
        smsCode: this.smsCode
      }
      store.dispatch('SmsLogin', params).then(() => {
        const query = this.$route.query
        const redirect = decodeURIComponent(query.redirect || '/profile')
        this.$router.push({ path: redirect })
      }).catch(() => {
      }).finally(() => {
        this.isLoading = false
      })
    },
    sendSmsCode() {
      if (this.timer) return
      if (!this.userName) {
        Toast('请输入正确的手机号')
        return
      }
      this.sendCodeLabel = this.count + afterSend
      sendSmsCode(this.userName).then(
        response => {
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
              this.sendCodeLabel = this.count + afterSend
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
              this.sendCodeLabel = beforeSend
              this.count = TIME_COUNT
            }
          }, 1000)
        }
      )
    },
    goLogin() {
      this.$router.push({name: 'Login', query: this.$route.query})
    }

  }
}
</script>

<style lang="css">
  .bm-register {
  }
  .bm-register .center {
    text-align: center;
  }
  .bm-register .submit {
    padding: 15px 20px;
  }
  .bm-register .margin-top {
    margin-top: 2px;
  }
  .bm-register .note {
    margin: 0 15px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/register.vue